const CONSTANTS = {
  EVENT_SERVICE_TYPE_IDS: [6, 7, 8],
  CANCEL_SUCCESS_MESSAGE: 'Notify cancelled!',
  SET_NOTIFY_SUCCESS_MESSAGE: (start, end) => `Notification from ${start} to ${end} created`,
  SET_NOTIFY: 'set_notify',
  TABLES_AVAILABLE: 'tables_available',
  SET_NOTIFY_SUCCESS: 'set_notify_success',
  BUTTON_ID_CHANGE: 'notify-button-change',
  BUTTON_ID_CONFIRM: 'notify-button-confirm',
  BUTTON_ID_CLOSE: 'notify-button-close',
  BUTTON_ID_SUCCESS: 'notify-button-success',
  BUTTON_ID_CANCEL: 'notify-button-cancel',
  BUTTON_ID_TABLES_AVAILABLE: 'notify-button-tables_available',
  POST_NOTIFY: 'post_notify',
};
const SERVICE_TYPES = {
  5: {
    name: 'breakfast',
    startTime: '06:00:00',
    endTime: '12:00:00',
  },
  1: {
    name: 'brunch',
    startTime: '09:00:00',
    endTime: '16:00:00',
  },
  3: {
    name: 'lunch',
    startTime: '10:00:00',
    endTime: '16:30:00',
  },
  2: {
    name: 'dinner',
    startTime: '17:00:00',
    endTime: '24:00:00',
  },
  6: {
    name: 'event 1',
    startTime: '00:00:00',
    endTime: '24:00:00',
  },
  7: {
    name: 'event 2',
    startTime: '00:00:00',
    endTime: '24:00:00',
  },
  8: {
    name: 'event 3',
    startTime: '00:00:00',
    endTime: '24:00:00',
  },
};
const NOOP = () => { };

/**
 * This allows for opening the modal contextually where the use is scrolled on the widget
 * Ultimately the value comes from outside the widget because
 * the scrolling mechanism is outside the iframe in
 * modalContainer
 * So the embed code broadcasts that value to the widget
 * using postMessage
 */
function getInset(scrollTop) {
  if (scrollTop) {
    return {
      inset: `${scrollTop}px 0 auto`,
    };
  }
  return undefined;
}

function getAuthModalStyles(breakpoints, scrollTop) {
  const desktopStyles = {
    borderRadius: '10px',
    bottom: 'auto',
    top: '10%',
    ...getInset(scrollTop),
  };

  const mobileStyles = {
    top: '15vh',
    left: 0,
    right: 0,
    bottom: 0,
    margin: '0 auto',
  };

  const responsiveStyles = breakpoints.xs && !breakpoints.sm ? mobileStyles : desktopStyles;

  return {
    content: {
      backgroundColor: '#fff',
      border: 'none',
      boxShadow: '0 10px 50px 0 rgba(0, 0, 0, 0.1)',
      margin: '0 auto',
      maxWidth: '600px',
      padding: '0',
      ...responsiveStyles,
    },
  };
}

export {
  CONSTANTS,
  SERVICE_TYPES,
  NOOP,
  getAuthModalStyles,
};
